
import { useState, useEffect } from 'react';
import { PhoneScreeningState } from '@/hooks/screening/types';
import { toast } from "sonner";

type ScreeningTab = 'phone' | 'interview' | 'fraud';

export function useScreeningTabs(
  phoneScreening: PhoneScreeningState,
  deepInterview: any
) {
  const [activeTab, setActiveTab] = useState<ScreeningTab>('phone');

  // Auto-advance tabs when a screening step is completed
  useEffect(() => {
    // When phone screening is completed, move to the interview tab
    if (phoneScreening.status === 'completed' && activeTab === 'phone') {
      const timer = setTimeout(() => {
        setActiveTab('interview');
        toast.info('Phone screening completed. Proceeding to technical interview.');
      }, 2000);
      
      return () => clearTimeout(timer);
    }
    
    // When interview is completed, move to the fraud detection tab
    if (deepInterview?.isComplete && activeTab === 'interview') {
      const timer = setTimeout(() => {
        setActiveTab('fraud');
        toast.info('Technical interview completed. Proceeding to fraud detection.');
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [phoneScreening.status, deepInterview, activeTab]);

  return { activeTab, setActiveTab };
}
